import { AxiosError } from 'axios';

import { ErrorData } from './error-data';
import { HandledError } from './handled-error';
import { request } from '../request';

export interface ErrorResult<T> {
    success: false;
    error?: ErrorData;
    errorCode?: number;
    requestCanceled?: boolean;
    handledErrors?: HandledError<T>[];
    errorHandled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface SuccessResult<T = any> {
    success: true;
    result: T;
}

export const errorResult = <T = string>(error?: AxiosError, handledErrors?: HandledError<T>[]): ErrorResult<T> => {
    const errorData = error?.response?.data as ErrorData;
    return {
        success: false,
        error: errorData,
        errorCode: error?.response?.status,
        requestCanceled: error && request.isCancel(error),
        handledErrors: handledErrors,
        errorHandled: !!handledErrors,
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const successResult = <T = any>(result: T): SuccessResult<T> => {
    return { success: true, result };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export declare type ApiResult<TResult = any, TError = any> = SuccessResult<TResult> | ErrorResult<TError>;
